import './normal-list-card.scss'

import React from 'react'

import Card from './card'

const config = {
  className: 'normal-list-card',
  minicard: false,
  hasNoImage: false,
  hasUnderline: true,
  hasNoLocationDisplay: true,
  isSearch: false,
  isCarousel: false,
}

export const NormalListCard = ({ item, ...restProps }) => (
  <Card item={item} {...config} {...restProps} />
)
